import { FormattedMessage } from 'react-intl';
import SubHeadline from '../../../atoms/SubHeadline';
import { EmbeddedAuthBaseProps } from '../../../organisms/EmbeddedAuth';
import SignIn from '../SignIn';

type WelcomeBackProps = EmbeddedAuthBaseProps & {
  returningCustomer: { firstName: string; lastName: string; email: string };
  onDifferentCustomer: () => void;
};

const WelcomeBack = ({ isEmbeddedAuth, returningCustomer, onDifferentCustomer }: WelcomeBackProps) => (
  <>
    <div className="auth-form__header">
      <SubHeadline>
        <FormattedMessage id="auth.returningCustomer.welcomeBack" values={returningCustomer} />
      </SubHeadline>
    </div>
    <div className="auth-form__greeting">
      <FormattedMessage id="auth.returningCustomer.greeting" />
    </div>
    <SignIn isEmbeddedAuth={isEmbeddedAuth} isWelcomeBack />
    <div className="form__row auth-form__different-account" onClick={onDifferentCustomer}>
      <div className="form__field-container">
        <FormattedMessage id="auth.returningCustomer.differentAccount" values={returningCustomer} />
      </div>
    </div>
  </>
);

export default WelcomeBack;
